import { AppAlertService } from './../../services/app-alert/app-alert.service';
import { FormBuilder } from '@angular/forms';
import { PersonService } from './../../services/person/person.service';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonModal, ModalController } from '@ionic/angular';
import { Person, CIRCLE_NAMES } from 'src/app/models/person';
import { ModalService } from 'src/app/services/modal/modal.service';
import { ActionSheetController } from '@ionic/angular';
import { OverlayEventDetail } from '@ionic/core/components';
import { EChartsOption } from 'echarts';

@Component({
  selector: 'app-person-page',
  templateUrl: './person-page.component.html',
  styleUrls: ['./person-page.component.scss'],
})
export class PersonPage implements OnInit {

  @Input('id') id: string;
  @Input('summary') summary: {
    name: string,
    picture: string
  };
  @ViewChild(IonModal) modal: IonModal;

  activeTab = 0;

  nav = {
    tabs: [
      {label: "Connections", selected: true},
      {label: "Profile", selected: false},
      {label: "Reports", selected: false},
    ]
  }

  messages: any = [
    {
      text: 'How do you like the latest app updates?',
      date: new Date(),
      reply: false,
      user: {
        name: 'Regis Burton',
        avatar: 'assets/avatars/M1.jpg',
      },
    },
    {
      text: 'Looks fantastic, I really like seeing the project timelines in my calender',
      date: new Date(),
      reply: true,
      user: {
        name: 'Imani Jacob',
        avatar: 'assets/avatars/F1.jpg',
      },
    },
    {
      text: 'Great to hear!',
      date: new Date(),
      reply: false,
      user: {
        name: 'Regis Burton',
        avatar: 'assets/avatars/M1.jpg',
      },
    },
  ]

  showAddConnection = false;

  person: Person;
  descriptionInput = this.fb.control('');
  pendingChanges = false;
  newChanges: Person;
  showBackdrop = false;
  isLoading = true; // Show skeleton loader

  chartOption: EChartsOption = {
    tooltip: {
      trigger: 'axis',
      formatter: '{b}<br/>Quality: {c}'
    },
    grid: {
      top: '2%',
      left: '3%',
      right: '4%',
      bottom: '10%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: [],
      axisLabel: {
        rotate: 45,
        margin: 8
      }
    },
    yAxis: {
      type: 'category',
      data: ['Poor', 'Neutral', 'Good', 'Great'],
      inverse: false,
      axisLabel: {
        margin: 8
      }
    },
    series: [
      {
        name: 'Connection Quality',
        type: 'line',
        data: [],
        itemStyle: { color: '#4CAF50' },
        smooth: true,
        areaStyle: {
          opacity: 0.1
        }
      }
    ]
  };

  mediumChartOption: EChartsOption = {
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)',
    },
    legend: {
      orient: 'horizontal', // Set the labels to be side by side
      left: 'center',       // Center the legend horizontally
      top: 10,              // Position the legend at the top
      textStyle: {
        fontSize: 12,
        color: '#666',       // Adjust the text color if needed
      },
    },
    series: [
      {
        name: 'Connection Medium',
        type: 'pie',
        radius: ['40%', '70%'], // Inner and outer radius for the donut effect
        avoidLabelOverlap: false,
        label: {
          show: true,
          position: 'center', // Position the label in the center of the donut
          formatter: '{b}\n{d}%', // Show the name and percentage
          fontSize: 14,
          fontWeight: 'bold',
        },
        labelLine: {
          show: false, // Hide the label lines
        },
        data: [
          { value: 1048, name: 'Email' },
          { value: 735, name: 'Phone' },
          { value: 580, name: 'In-Person' },
          { value: 484, name: 'Social Media' },
        ],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
      },
    ],
  };

  initiatorChartOption: EChartsOption = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: ['Me', 'Them', 'N/A'],
      axisLabel: {
        margin: 8
      }
    },
    yAxis: {
      type: 'value',
      name: '# Connections',
      axisLabel: {
        margin: 8
      }
    },
    series: [
      {
        name: 'Initiator',
        type: 'bar',
        data: [],
        itemStyle: {
          color: '#4CAF50'
        },
        emphasis: {
          itemStyle: {
            color: '#4CAF50'
          }
        }
      },
      {
        name: 'Them',
        type: 'bar',
        data: [],
        itemStyle: {
          color: '#2196F3'
        },
        emphasis: {
          itemStyle: {
            color: '#2196F3'
          }
        }
      },
      {
        name: 'N/A',
        type: 'bar',
        data: [],
        itemStyle: {
          color: '#FFC107'
        },
        emphasis: {
          itemStyle: {
            color: '#FFC107'
          }
        }
      }
    ]
  };

  reportsQualityChartOption: EChartsOption = {
    tooltip: {
      trigger: 'axis',
      formatter: '{b}<br/>Quality: {c}'
    },
    grid: {
      top: '2%',
      left: '3%',
      right: '4%',
      bottom: '10%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: [],
      axisLabel: {
        rotate: 45,
        margin: 8
      }
    },
    yAxis: {
      type: 'category',
      data: ['Poor', 'Neutral', 'Good', 'Great'],
      inverse: false,
      axisLabel: {
        margin: 8
      }
    },
    series: [
      {
        name: 'Connection Quality',
        type: 'line',
        data: [],
        itemStyle: { color: '#4CAF50' },
        smooth: true,
        areaStyle: {
          opacity: 0.1
        }
      }
    ]
  };

  selectedTimeRange = 'all';
  timeRanges = [
    { value: 'week', label: 'Past Week' },
    { value: 'month', label: 'Past Month' },
    { value: 'all', label: 'All Time' }
  ];

  reportsDataAvailable: boolean = false; // Default to false

  constructor(
    private modalCtrl: ModalController,
    private modalService: ModalService,
    private personService: PersonService,
    private fb: FormBuilder,
    private actionSheetCtrl: ActionSheetController,
    private alertService: AppAlertService
  ) { }

  async ngOnInit() {
    this.isLoading = true; // Show skeleton loader
    await this.loadPerson();
    this.isLoading = false; // Hide skeleton loader after data is loaded

    this.descriptionInput = this.fb.control(this.person.description);

    this.newChanges = {
      documentId: this.id
    };

    this.descriptionInput.valueChanges.subscribe({

      next: (val)=>{

        if (val != this.person.description) {
          this.newChanges.description = val;
          this.pendingChanges = true;
          this.person.description = val;
        }

    }});

    this.checkReportsData();
  }

  async loadPerson(){
    this.person = await this.personService.getPerson(this.id);
    this.updateChartData();
    console.log(this.person);
    return this.person;
  }

  private updateChartData() {
    if (!this.person?.connections) return;

    // Filter connections based on selected time range
    const now = new Date();
    const filteredConnections = this.person.connections.filter(connection => {
      const connectionDate = new Date(connection.date);
      switch (this.selectedTimeRange) {
        case 'week':
          return connectionDate >= new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
        case 'month':
          return connectionDate >= new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
        default:
          return true;
      }
    });

    // Group connections by day and quality
    const connectionsByDay = filteredConnections.reduce((acc, connection) => {
      const date = new Date(connection.date);
      const dayDate = date.toLocaleDateString('default', { 
        month: 'short', 
        day: 'numeric',
        year: 'numeric' 
      });
      
      if (!acc[dayDate]) {
        acc[dayDate] = { great: 0, good: 0, okay: 0, bad: 0, total: 0 };
      }

      const quality = connection.quality || 'okay';
      acc[dayDate][quality]++;
      acc[dayDate].total++;
      
      return acc;
    }, {});

    // Sort by date
    const sortedDays = Object.keys(connectionsByDay).sort((a, b) => {
      return new Date(a).getTime() - new Date(b).getTime();
    });

    // Calculate dominant quality for each day
    const qualityScores = sortedDays.map(day => {
      const dayData = connectionsByDay[day];
      const total = dayData.total;
      
      // Find the quality with the highest count
      const qualities = [
        { name: 'Great', count: dayData.great },
        { name: 'Good', count: dayData.good },
        { name: 'Neutral', count: dayData.okay },
        { name: 'Poor', count: dayData.bad || 0 },
      ];
      
      const dominantQuality = qualities.reduce((prev, current) => 
        (current.count > prev.count) ? current : prev
      );
      
      return dominantQuality.name;
    });

    // Update chart data
    this.chartOption = {
      ...this.chartOption,
      xAxis: {
        ...this.chartOption.xAxis,
        data: sortedDays,
        axisLabel: {
          rotate: 45,
          formatter: (value) => {
            const date = new Date(value);
            return `${date.getMonth() + 1}/${date.getDate()}`;
          }
        }
      },
      series: [
        {
          ...this.chartOption.series[0],
          data: qualityScores
        }
      ]
    };

    // Update medium chart data
    const mediumData = filteredConnections.reduce((acc, connection) => {
      const medium = connection.medium || 'Other';
      acc[medium] = (acc[medium] || 0) + 1;
      return acc;
    }, {});

    this.mediumChartOption = {
      ...this.mediumChartOption,
      series: [{
        ...this.mediumChartOption.series[0],
        data: Object.entries(mediumData).map(([name, value]) => ({
          name,
          value
        }))
      }]
    };

    // Update initiator chart data
    const initiatorData = filteredConnections.reduce((acc, connection) => {
      const initiator = connection.initiator || 'none';
      acc[initiator] = (acc[initiator] || 0) + 1;
      return acc;
    }, {});

    this.initiatorChartOption = {
      ...this.initiatorChartOption,
      series: [
        {
          ...this.initiatorChartOption.series[0],
          data: [initiatorData['me'] || 0, 0, 0]
        },
        {
          ...this.initiatorChartOption.series[1],
          data: [0, initiatorData['them'] || 0, 0]
        },
        {
          ...this.initiatorChartOption.series[2],
          data: [0, 0, initiatorData['none'] || 0]
        }
      ]
    };

    // Update reports quality chart data
    this.reportsQualityChartOption = {
      ...this.reportsQualityChartOption,
      xAxis: {
        ...this.reportsQualityChartOption.xAxis,
        data: sortedDays,
        axisLabel: {
          rotate: 45,
          formatter: (value) => {
            const date = new Date(value);
            return `${date.getMonth() + 1}/${date.getDate()}`;
          }
        }
      },
      series: [
        {
          ...this.reportsQualityChartOption.series[0],
          data: qualityScores
        }
      ]
    };
  }

  checkReportsData() {
    // Example logic to check if data is available
    this.reportsDataAvailable = this.person?.connections?.length > 0;
  }

  onTimeRangeChange() {
    this.updateChartData();
  }

  async handleRefresh(event){
    
    await this.loadPerson()
    event.target.complete();
  }
  
  sendMessage(event: any) {
    const files = !event.files ? [] : event.files.map((file) => {
      return {
        url: file.src,
        type: file.type,
        icon: 'file-text-outline',
      };
    });

    this.messages.push({
      text: event.message,
      date: new Date(),
      reply: true,
      type: files.length ? 'file' : 'text',
      files: files,
      user: {
        name: 'Jonh Doe',
        avatar: 'https://i.gifer.com/no.gif',
      },
    });

  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalCtrl.dismiss({
      'dismissed': true
    });
  }


  goToTab(i){
    this.activeTab = i;
  }

  setCurrentTab(index){
    this.activeTab = index;
  }

  buttonClicked(button){
    if (button=='inbox'){
      // this.modalService.openInbox()
    }
  }


  async newConnection(){
    let modal = await this.modalService.openConnectionForm(null, this.person.documentId)
    const { data, role } = await modal.onWillDismiss();
    this.loadPerson()
  }

  async changeCircle(selected=null) {
    const actionSheet = await this.actionSheetCtrl.create({
      header: 'Select Circle',
      buttons: [
        {
          text: 'Inner Circle',
          role: selected == 'inner' ?  'selected' : null,
          data: {
            action: 'inner',
          },
        },
        {
          text: 'Close Circle',
          role: selected == 'close' ?  'selected' : null,
          data: {
            action: 'close',
          },
        },
        {
          text: 'Casual Circle',
          role: selected == 'casual' ?  'selected' : null,
          data: {
            action: 'casual',
          },
        },
        {
          text: 'Cancel',
          role: 'cancel',
          data: {
            action: 'cancel',
          },
        },
      ],
    });

    await actionSheet.present();

    let result = await actionSheet.onDidDismiss();
    let action = result.data.action;

    if (action != this.person.circle) {
      this.newChanges.circle = action;
      this.pendingChanges = true;
      this.person.circle = action;
      this.person.circleName = CIRCLE_NAMES[action];
    }
  }

  async changeContactPeriod(selected=null) {
    const actionSheet = await this.actionSheetCtrl.create({
      header: 'Select Contact Period',
      buttons: [
        {
          text: 'Daily',
          role: selected == 'daily' ?  'selected' : null,
          data: {
            action: 'daily',
          },
        },
        {
          text: 'Weekly',
          role: selected == 'weekly' ?  'selected' : null,
          data: {
            action: 'weekly',
          },
        },
        {
          text: 'Bi-weekly',
          role: selected == 'bi-weekly' ?  'selected' : null,
          data: {
            action: 'bi-weekly',
          },
        },
        {
          text: 'Monthly',
          role: selected == 'monthly' ?  'selected' : null,
          data: {
            action: 'monthly',
          },
        },
        {
          text: 'Cancel',
          role: 'cancel',
          data: {
            action: 'cancel',
          },
        },
      ],
    });

    await actionSheet.present();

    let result = await actionSheet.onDidDismiss();
    let action = result.data.action;

    if (action != this.person.contactPeriod) {
      this.newChanges.contactPeriod = action;
      this.pendingChanges = true;
      this.person.contactPeriod = action;

    }

  }

  async changeDOB(event) {

    let action = event?.detail?.value;

    if (action != this.person.dob) {
      this.newChanges.dob = action;
      this.pendingChanges = true;
      this.person.dob = action;
    }

  }

  savePerson(){
    this.personService.editPerson(this.id, this.person).then(()=>{
      this.alertService.showSuccessAlert("Saved Successfully")
      this.pendingChanges = false;
      this.newChanges = {
        documentId: this.id
      }
    }).catch((e)=>{
      this.alertService.showErrorAlert("Failed to Save: " + e?.message)
    })
  }

  onDismissDateModal(event: Event) {
    const ev = event as CustomEvent<OverlayEventDetail<string>>;
    if (ev.detail.role === 'confirm') {
      this.person.dob = new Date(ev.detail.data);
    }
  }

  async editPerson(){
    this.showBackdrop = true;
    let modal = await this.modalService.openCreatePersonForm(this.person)
    const { data, role } = await modal.onWillDismiss();

    if (data.data === 'deleted') this.dismiss()
    if (data.data === 'saved') {
      this.loadPerson()
    }
    this.showBackdrop = false;
  }

  refreshConnections(doRefresh: boolean){
    this.loadPerson()
  }


}
